
const FormatFileSize = (bytes: number) => {
    if (!bytes || bytes < 0) return "0 B";
  
    const units = ["B", "KB", "MB", "GB", "TB"];
    let size = bytes;
    let unitIndex = 0;
  
    while (size >= 1024 && unitIndex < units.length - 1) {
      size /= 1024;
      unitIndex++;
    }
  
    return `${size.toFixed(size < 10 ? 2 : 1)} ${units[unitIndex]}`;
  };

  export default FormatFileSize;